<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { getProductDataForGTM, onClickWishlist } from '../../../common/util';
  import ProductTileMain from './productTile/ProductTileMain.svelte';

  export let data;
  export let index;
  const { encodedContextPath = 'en-sa' } = getAppConfig();
</script>

<a href={`${encodedContextPath}${data?.urlEn}`} on:click|preventDefault={() => {}} class="link">
  <ProductTileMain
    {data}
    options={{ showActionBtn: false, showBottomTags: true }}
    on:toggleFav={x => {
      onClickWishlist(x, data.code || data.productCode);
    }}
    productDataForGTM={getProductDataForGTM(data, index)}
  />
</a>
